import React from 'react';

const buttonVariants = {
  primary: 'bg-primary text-primary-foreground hover:bg-primary-hover hover:text-primary-foreground shadow-sm',
  secondary: 'bg-background-soft text-foreground hover:bg-surface-hover hover:text-foreground border border-border/60 hover:border-border',
  accent: 'bg-accent text-accent-foreground hover:bg-accent-hover hover:text-accent-foreground shadow-sm',
  danger: 'bg-danger text-danger-foreground hover:bg-danger-hover hover:text-danger-foreground shadow-sm',
  ghost: 'text-muted-foreground hover:bg-background-soft hover:text-foreground',
  link: 'text-primary hover:text-primary-hover underline-offset-4 hover:underline',
};

const buttonSizes = {
  sm: 'px-3 py-1.5 text-xs',
  md: 'px-4 py-2 text-sm',
  lg: 'px-6 py-3 text-base',
};

export const Button = ({ 
  children, 
  variant = 'primary', 
  size = 'md',
  className = '',
  disabled = false,
  ...props 
}) => {
  const baseStyles = 'inline-flex items-center justify-center font-medium rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-accent/50 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed disabled:pointer-events-none';
  
  return (
    <button
      {...props}
      disabled={disabled}
      className={`${baseStyles} ${buttonVariants[variant]} ${buttonSizes[size]} ${className}`}
    >
      {children}
    </button>
  );
};
